module.exports = __webpack_public_path__ + "static/media/vip1.f895c974.png";